
import React, { useEffect } from 'react';
import HeroSection from './HeroSection';
import ValueProposition from './ValueProposition';
import HowItWorks from './HowItWorks';
import UseCases from './UseCases';
import Pricing from './Pricing';
import SampleReport from './SampleReport';
import CallToAction from './CallToAction';
import Footer from './Footer';
import NavigationBar from './NavigationBar';
import ScrollProgressIndicator from './ScrollProgressIndicator';
import { useScrollSections } from '@/hooks/useScrollSections';
import { useLocation } from 'react-router-dom';

/**
 * LandingPage component
 * Main container for all landing page sections with enhanced scroll behavior
 */
const LandingPage = () => {
  const { scrollProgress, smoothScrollToSection } = useScrollSections();
  const location = useLocation();
  
  useEffect(() => {
    // Apply initial window scroll position
    window.scrollTo(0, 0);
    
    // Check if we arrived with a scroll target in state
    if (location.state && location.state.scrollToId) {
      const targetId = location.state.scrollToId;
      const element = document.getElementById(targetId);
      
      if (element) {
        // Wait a bit for the page to fully load then scroll
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      
      // Clear the state so we don't scroll again on subsequent updates
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  
  return (
    <div className="min-h-screen bg-gray-900 text-white overflow-x-hidden">
      {/* Scroll progress indicator */}
      <ScrollProgressIndicator progress={scrollProgress} />
      
      <NavigationBar />
      
      <main>
        <HeroSection />
        <section id="features">
          <ValueProposition />
          <HowItWorks />
        </section>
        <section id="use-cases">
          <UseCases />
          <SampleReport />
        </section>
        <section id="pricing">
          <Pricing />
        </section>
        <CallToAction />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
